import React from 'react';

import './styles.css';

function Card({ className, title, description, disabled, children }) {
  return (
    <div className={`wa-card ${className}`}>
      <div className="wa-card__header">
        <h5>{title}</h5>
        {description && (
          <p>{description}</p>
        )}
      </div>
      <div className={`wa-card__body${disabled ? ' disabled' : ''}`}>
        {children}
      </div>
    </div>
  );
}

export default Card;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/ui/Card/index.js